import { render, staticRenderFns } from "./products-edit.vue?vue&type=template&id=076e4550&"
import script from "./products-edit.vue?vue&type=script&lang=js&"
export * from "./products-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076e4550')) {
      api.createRecord('076e4550', component.options)
    } else {
      api.reload('076e4550', component.options)
    }
    module.hot.accept("./products-edit.vue?vue&type=template&id=076e4550&", function () {
      api.rerender('076e4550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/products-edit.vue"
export default component.exports